import { render } from "./SemanaComponent.vue?vue&type=template&id=5723c76c"
import script from "./SemanaComponent.vue?vue&type=script&lang=js"
export * from "./SemanaComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__